import axios from 'axios'
import { toast } from 'react-toastify'
import { baseUrl } from '@config/environment.config'
import Cookies from 'js-cookie'

const api = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'cs',
    'Content-Language': 'cs',
  },
})

api.interceptors.request.use((request) => {
  request.headers['X-CSRFToken'] = Cookies.get('csrftoken')
  return request
})

api.interceptors.response.use(undefined, function axiosRetryInterceptor(error) {
  if (
    error.response &&
    (error.response.status == 401 || error.response.status == 403) &&
    !window.location.href.endsWith('/login')
  ) {
    console.log(`user on path: ${window.location.href}. Rerouting`)
    window.location.href = '/login'
  } else if (!error.response || error.response.status == 500) {
    toast.error('Problém s připojením. Zkuste prosím akci později')
  }

  return Promise.reject(error)
})

export default api
